import { inject } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { DateFormats, formatDateToString } from '@core';
import { AdminUsersFiltersStorage, UsersListService } from '@admin-panel/infra';
import { AdminUserDto, GetAdminUsersResponse } from '@core-http';
import { AdminUserQueryResult } from './get-admin-users-list.query-result';
import { AdminUsersFiltersModel } from '../../../models';

export class GetAdminUsersListQueryHandler {
  private readonly usersListService: UsersListService = inject(UsersListService);
  private readonly adminUsersFiltersStorage: AdminUsersFiltersStorage = inject(AdminUsersFiltersStorage);

  query(): Observable<AdminUserQueryResult[]> {
    return this.adminUsersFiltersStorage.filters$.pipe(
      switchMap((filters: AdminUsersFiltersModel) => this.usersListService.getUsers(filters.search || undefined)),
      map((response: GetAdminUsersResponse) => this.mapToResult(response)),
      map((users: AdminUserQueryResult[]) =>
        [...users].sort((a: AdminUserQueryResult, b: AdminUserQueryResult) => b.registerDate - a.registerDate)
      )
    );
  }

  private mapToResult(response: GetAdminUsersResponse): AdminUserQueryResult[] {
    return response.users.map((dto: AdminUserDto) => ({
      userId: dto.userId,
      name: dto.name,
      lastName: dto.lastName,
      thumbnailUrl: dto.thumbnailUrl,
      email: dto.email,
      role: dto.role,
      registerDate: dto.registerDate,
      formattedRegisterDate: formatDateToString(dto.registerDate, DateFormats.DayMonthYearDotShort),
      formattedRegisterTime: formatDateToString(dto.registerDate, DateFormats.Time),
      lastLoginDate: dto.lastLoginDate,
      versionInfo: dto.versionInfo,
      platform: dto.platform,
      regionName: dto.region?.name ?? null,
      isVerified: dto.isVerified,
      isHighlighted: dto.isHighlighted,
      isBanned: dto.isBanned,
      stats: {
        hostedGames: dto.stats.hostedGames,
        playedGames: dto.stats.playedGames,
        gameApplications: dto.stats.gameApplications
      }
    }));
  }
}
